import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutofocusDirective } from './autofocus.directive';
import { BlurOnEscapeDirective } from './blur-on-escape.directive';
import { EventFenceDirective } from './event-fence.directive';
import { FlagExternalDirective } from './flag-external.directive';
import { FlagInternalDirective } from './flag-internal.directive';
import { LazyCardsDirective } from './lazy-cards.directive';
import { SelectOnFocusDirective } from './select-on-focus.directive';

@NgModule({
  declarations: [
    AutofocusDirective,
    BlurOnEscapeDirective,
    EventFenceDirective,
    FlagExternalDirective,
    FlagInternalDirective,
    LazyCardsDirective,
    SelectOnFocusDirective
  ],
  exports: [
    AutofocusDirective,
    BlurOnEscapeDirective,
    EventFenceDirective,
    FlagExternalDirective,
    FlagInternalDirective,
    LazyCardsDirective,
    SelectOnFocusDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
